/* Os dois valores que vinham de `theme/palette` foram TRAZIDOS PARA CA em
   19/08/2026, quando o tema do MUI foi removido.

   Eram exatamente dois: o preset "default" (o primary do tema) e o `contrastText`
   de tres presets claros (o cinza 800). Manter um arquivo de tema inteiro do MUI
   de pe por causa de duas cores nao se justificava, e copiar cor sem dizer de onde
   veio e o que produz divergencia depois - dai o registro aqui.

   Os valores sao os mesmos, conferidos no arquivo antes de apagar. */
const PRIMARY_PADRAO = {
  lighter: '#182D45',
  light: '#76B0F1',
  main: '#182d45',
  dark: '#103996',
  darker: '#182D45',
  contrastText: '#fff',
};
/** `grey[800]` do tema antigo - texto escuro sobre preset claro. */
const CINZA_800 = '#212B36';

// ----------------------------------------------------------------------

export const colorPresets = [
  // DEFAULT
  {
    name: 'default',
    ...PRIMARY_PADRAO,
  },
  // PURPLE
  {
    name: 'purple',
    lighter: '#EBD6FD',
    light: '#B985F4',
    main: '#7635dc',
    dark: '#431A9E',
    darker: '#200A69',
    contrastText: '#fff',
  },
  // CYAN
  {
    name: 'cyan',
    lighter: '#D1FFFC',
    light: '#76F2FF',
    main: '#1CCAFF',
    dark: '#0E77B7',
    darker: '#053D7A',
    contrastText: CINZA_800,
  },
  // BLUE
  {
    name: 'blue',
    lighter: '#D1E9FC',
    light: '#76B0F1',
    main: '#2065D1',
    dark: '#103996',
    darker: '#061B64',
    contrastText: '#fff',
  },
  // ORANGE
  {
    name: 'orange',
    lighter: '#FEF4D4',
    light: '#FED680',
    main: '#fda92d',
    dark: '#B66816',
    darker: '#793908',
    contrastText: CINZA_800,
  },
  // RED
  {
    name: 'red',
    lighter: '#FFE3D5',
    light: '#FFC1AC',
    main: '#FF3030',
    dark: '#B71833',
    darker: '#7A0930',
    contrastText: '#fff',
  },
  // GPS
  {
    // name: 'gps',
    name: 'green',
   lighter: '#C8FACD',
   light: '#5BE584',
   main: '#00AB55',
   dark: '#007B55',
   darker: '#005249',
  },
];

export const defaultPreset = colorPresets[0];
export const purplePreset = colorPresets[1];
export const cyanPreset = colorPresets[2];
export const bluePreset = colorPresets[3];
export const orangePreset = colorPresets[4];
export const redPreset = colorPresets[5];
export const greenPreset = colorPresets[6];

export default function getColorPresets(presetsKey) {
  return {
    purple: purplePreset,
    cyan: cyanPreset,
    blue: bluePreset,
    orange: orangePreset,
    red: redPreset,
    green: greenPreset,
    default: defaultPreset,
  }[presetsKey];
}
